<template>
    <div
        class="h-9 w-9 rounded-full bg-gray-300 p-2 text-center text-[15px] font-medium text-gray-800"
    >
        {{ user.initials }}
    </div>
</template>
<script>
export default {
    name: "UserInitialsRound",
    props: {
        user: {},
    },
};
</script>
